import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './restaurantFeatures.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type RestaurantFeaturesQuery_restaurantBySlug_Restaurant_featureSetting_RestaurantFeatureSetting = {
  __typename: 'RestaurantFeatureSetting',
  id: number,
  isAccessibilityFooterIconEnabled: boolean,
  isAiAnsweringEnabled: boolean,
  isAiAnsweringLocked: boolean,
  isAiMarketingCalendarEnabled: boolean,
  isAiMarketingCalendarPerLocationEnabled: boolean,
  isMultiChannelCampaignAiEnabled: boolean,
  isApplePayEnabled: boolean,
  isBoostAiMarketingCalendarEnabled: boolean,
  isCspHeaderEnabled: boolean,
  isCurbsideEnabled: boolean,
  isDeveloperApiEnabled: boolean,
  isDishCustomHtmlEnabled: boolean,
  isDraftsUndoEnabled: boolean,
  isEnablingDrafts: boolean,
  isFacebookCampaignsEnabled: boolean,
  isFeedbackEnabled: boolean,
  isFollowerImportEnabled: boolean,
  isForceSyncMenusEnabled: boolean,
  isGiftCardPurchasingEnabled: boolean,
  isGiftCardsEnabled: boolean,
  isGiftCardsLocked: boolean,
  isInstagramEnabled: boolean,
  isInstagramFeedEnabled: boolean,
  isItemCardV2Enabled: boolean,
  isLoyaltyEnabled: boolean,
  isMarketingCalendarEnabled: boolean,
  isMenuSyncUiEnabled: boolean,
  isMessageDetailsOverviewEnabled: boolean,
  isMessagePacksEnabled: boolean,
  isMessagePacksLocked: boolean,
  isMobileOrderDetailsV2Enabled: boolean,
  isNcrSilverEnabled: boolean,
  isNestedModifiersEnabled: boolean,
  isOrderingCateringEnabled: boolean,
  isOrderingCateringLocked: boolean,
  isOrderingDeliveryEnabled: boolean,
  isOrderingEventsEnabled: boolean,
  isOrderingEventsLocked: boolean,
  isOrderingDineInEnabled: boolean,
  isOrderingDineInLocked: boolean,
  isOrderingDoorDashEnabled: boolean,
  isOrderingEnabled: boolean,
  isOrderingPaymentEnabled: boolean,
  isOrderingRefundsEnabled: boolean,
  isOrdernerdEnabled: boolean,
  isOtterV2Enabled: boolean,
  isPopmenuLoyaltyEnabled: boolean,
  isPrintCenterEnabled: boolean,
  isPrintCenterLocked: boolean,
  isProfileV2Enabled: boolean,
  isReservationsEnabled: boolean,
  isRoiAlertsEnabled: boolean,
  isShowVipPromptOnHomePageOnlyEnabled: boolean,
  isThirdPartyLoyaltyEnabled: boolean,
  isTextMessageEnabled: boolean,
  isTextMessageLocked: boolean,
  isWaitlistEnabled: boolean,
  isWaitlistLocked: boolean,
  isWaitlistV2Enabled: boolean,
  isAiReviewResponseEnabled: boolean,
  isYextReviewsEnabled: boolean,
  isAutoRevShareCustomFeesCreationEnabled: boolean,
  isConsumerMobileAppEnabled: boolean
};

export type RestaurantFeaturesQuery_restaurantBySlug_Restaurant = {
  __typename: 'Restaurant',
  id: number,
  featureFlags?: Record<string, boolean> | null,
  featureSetting?: RestaurantFeaturesQuery_restaurantBySlug_Restaurant_featureSetting_RestaurantFeatureSetting | null
};

export type RestaurantFeaturesQuery_Query = {
  __typename?: 'Query',
  restaurantBySlug: RestaurantFeaturesQuery_restaurantBySlug_Restaurant
};


export type RestaurantFeaturesQueryVariables = Types.Exact<{
  restaurantSlug: Types.Scalars['String']['input'];
}>;


export type RestaurantFeaturesQuery = RestaurantFeaturesQuery_Query;


export const RestaurantFeaturesDocument = /*#__PURE__*/ document as unknown as DocumentNode<RestaurantFeaturesQuery, RestaurantFeaturesQueryVariables>;


/**
 * __useRestaurantFeaturesQuery__
 *
 * To run a query within a React component, call `useRestaurantFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestaurantFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestaurantFeaturesQuery({
 *   variables: {
 *      restaurantSlug: // value for 'restaurantSlug'
 *   },
 * });
 */
export function useRestaurantFeaturesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RestaurantFeaturesQuery, RestaurantFeaturesQueryVariables> & ({ variables: RestaurantFeaturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RestaurantFeaturesQuery, RestaurantFeaturesQueryVariables>(RestaurantFeaturesDocument, options);
      }
export function useRestaurantFeaturesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RestaurantFeaturesQuery, RestaurantFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RestaurantFeaturesQuery, RestaurantFeaturesQueryVariables>(RestaurantFeaturesDocument, options);
        }
// @ts-ignore
export function useRestaurantFeaturesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RestaurantFeaturesQuery, RestaurantFeaturesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RestaurantFeaturesQuery, RestaurantFeaturesQueryVariables>;
export function useRestaurantFeaturesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RestaurantFeaturesQuery, RestaurantFeaturesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RestaurantFeaturesQuery | undefined, RestaurantFeaturesQueryVariables>;
export function useRestaurantFeaturesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RestaurantFeaturesQuery, RestaurantFeaturesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RestaurantFeaturesQuery, RestaurantFeaturesQueryVariables>(RestaurantFeaturesDocument, options);
        }
export type RestaurantFeaturesQueryHookResult = ReturnType<typeof useRestaurantFeaturesQuery>;
export type RestaurantFeaturesLazyQueryHookResult = ReturnType<typeof useRestaurantFeaturesLazyQuery>;
export type RestaurantFeaturesSuspenseQueryHookResult = ReturnType<typeof useRestaurantFeaturesSuspenseQuery>;
export type RestaurantFeaturesQueryResult = ApolloReactCommon.QueryResult<RestaurantFeaturesQuery, RestaurantFeaturesQueryVariables>;